<template lang="pug">
  .haveNotThisPage
    p 您找的页面不见了，返回首页继续浏览吧
    button(@click="gotoHome") 返回首页
</template>

<script>
  export default {
    name: "haveNotThisPage",
    methods: {
      gotoHome() {
        this.$router.replace({name: 'Home'});
      },
    },
  };
</script>

<style scoped lang="stylus">
  .haveNotThisPage {
    background url("../../assets/images/404.png") no-repeat center
    height 100vh
    overflow hidden
    display flex
    justify-content flex-start
    align-items center
    flex-direction column
    background-color #f2f2f3
    p {
      color #a9abae
      margin-top 550px
    }
    button {
      border none
      outline none
      background-color #a9abae
      color #fff
      margin-top 50px
      height 30px
      width 90px
      border-radius 15px
    }
    @media (max-width 790px) {
      background-size 960px
      background-position top
      p {
        margin-top 300px
      }
    }
    @media (max-width 500px) {
      p {
        margin-top 100px
      }
    }
  }
</style>
